"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Step1 = void 0;

var react_1 = __importStar(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var Card_1 = require("../../components/Card");

var ComposedLabels_1 = require("../../components/ComposedLabels");

var Iban_1 = require("../../components/Iban/Iban");

var IbanForm_1 = require("../../components/Iban/IbanForm");

var IbanFormWithMandat_1 = require("../../components/Iban/IbanFormWithMandat");

var referenceFormatter_1 = __importDefault(require("../../utils/referenceFormatter"));

exports.Step1 = function (_a) {
  var goToNextStep = _a.goToNextStep,
      callPostIban = _a.callPostIban,
      loaderSubmit = _a.loaderSubmit,
      messageError = _a.messageError,
      dataUser = _a.dataUser,
      address = _a.address,
      price = _a.price,
      _b = _a.iban,
      iban = _b === void 0 ? "" : _b,
      isMandat = _a.isMandat,
      _c = _a.titulaire,
      titulaire = _c === void 0 ? "" : _c,
      customerServiceURL = _a.customerServiceURL,
      termsOfUseURL = _a.termsOfUseURL,
      mobile = _a.mobile,
      firstName = _a.firstName,
      lastName = _a.lastName,
      modeOfPayment = _a.modeOfPayment,
      isIbanDifferentWithSearchMandate = _a.isIbanDifferentWithSearchMandate,
      _d = _a.fromPlatform,
      fromPlatform = _d === void 0 ? "part" : _d;

  var _e = __read(react_1.useState(!isMandat || !iban ? true : false), 2),
      showFormIban = _e[0],
      setShowIbanForm = _e[1];

  var _f = __read(react_1.useState(false), 2),
      showFullForm = _f[0],
      setShowFullForm = _f[1];

  var IbanFormToShow = isMandat ? IbanFormWithMandat_1.IbanFormWithMandat : IbanForm_1.IbanForm;

  var updateIban = function updateIban() {
    setShowIbanForm(true);
    setShowFullForm(true);
  };

  var dataUserFormatter = function dataUserFormatter(dataUser) {
    if (!dataUser) {
      return [];
    }

    var formattedDataUser = __spread(dataUser);

    formattedDataUser[1] = referenceFormatter_1.default(formattedDataUser[1]);
    return formattedDataUser;
  };

  react_1.useEffect(function () {
    setMyKey(Date.now());
    setShowIbanForm(!isMandat || !iban ? true : false);
  }, [iban, isMandat, mobile]);

  var _g = __read(react_1.useState(Date.now()), 2),
      key = _g[0],
      setMyKey = _g[1];

  return react_1.default.createElement("div", {
    className: "container px-md-5",
    key: key
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "h2",
    weight: "bold"
  }, "D\xE9tail du contrat"), react_1.default.createElement(ComposedLabels_1.ComposedLabels, {
    labels: dataUserFormatter(dataUser)
  }), react_1.default.createElement("div", {
    className: "row mb-4 mb-md-5"
  }, react_1.default.createElement("div", {
    className: "col-12 col-md-6 pr-md-4 mb-md-0 mb-3"
  }, react_1.default.createElement(Card_1.Card, {
    title: "Adresse de facturation",
    className: "cy-bloc-billing",
    text: address
  })), react_1.default.createElement("div", {
    className: "col-12 col-md-6 pl-md-4"
  }, react_1.default.createElement(Card_1.Card, {
    title: "Solde \xE0 r\xE9gler",
    className: "cy-bloc-balance",
    text: price,
    align: "center",
    transparent: true,
    border: false
  }))), isMandat === true && isIbanDifferentWithSearchMandate === true ? react_1.default.createElement(IbanForm_1.IbanForm, {
    onSubmit: goToNextStep,
    loaderSubmit: loaderSubmit,
    iban: iban,
    messageError: messageError,
    isMandat: isMandat,
    showFullForm: showFullForm,
    customerServiceURL: customerServiceURL,
    termsOfUseURL: termsOfUseURL,
    mobile: mobile,
    firstName: firstName,
    lastName: lastName,
    modeOfPayment: modeOfPayment,
    isIbanDifferentWithSearchMandate: isIbanDifferentWithSearchMandate,
    fromPlatform: fromPlatform
  }) : !showFormIban ? react_1.default.createElement(Iban_1.Iban, {
    iban: iban,
    loaderSubmit: loaderSubmit,
    messageError: messageError,
    titulaire: titulaire,
    showTitulaire: true,
    onClick: updateIban,
    callPostIban: callPostIban,
    modeOfPayment: modeOfPayment
  }) : react_1.default.createElement(IbanFormToShow, {
    onSubmit: goToNextStep,
    loaderSubmit: loaderSubmit,
    iban: iban,
    messageError: messageError,
    isMandat: isMandat,
    showFullForm: showFullForm,
    customerServiceURL: customerServiceURL,
    termsOfUseURL: termsOfUseURL,
    mobile: mobile,
    firstName: firstName,
    lastName: lastName,
    modeOfPayment: modeOfPayment,
    fromPlatform: fromPlatform
  }));
};

exports.default = exports.Step1;